import {
  Container,
  Row,
  Text,
  Card,
  Grid
} from "@nextui-org/react";
import {
  KanoodleBoard,
  KanoodlePieceChooser,
} from "../components/kanoodleComponents";
import { useState, useEffect } from "react";

export const Home = () => {
  const [transformKanoodlePiece, setTransformKanoodlePiece] = useState(null);
  const [updateKanoodleBoardStateRefresh, setUpdateKanoodleBoardStateRefresh] =
    useState(Math.random());

  useEffect(() => {
    setUpdateKanoodleBoardStateRefresh(Math.random());
  }, [transformKanoodlePiece]);

  return (
    <Container xl>
      <Grid.Container gap={1} justify="center">
        <Grid justify="center">
          <Text h2>Welcome to the </Text>
        </Grid>
        <Grid justify="center">
          <Text h1 css={{ textAlign: "center" }}>
            <span style={{ color: "#DF853C" }}>Kanoodle</span>{" "}
            <span style={{ color: "#135E8C" }}>Challenge</span>{" "}
            <span style={{ color: "#2A9174" }}>Solver</span>
          </Text>
        </Grid>
      </Grid.Container>
      <hr />
      <Container>
        <Row justify="center">
          <Text h3>Set up your Kanoodle!</Text>
        </Row>
        <br />
        <Row justify="center">
          <Grid xs={10}>
            <Card>
              <Card.Body>
                <Text>
                  Select a random Kanoodle piece and shake it in your container
                  randomly stopping at some point. Open up your container, and
                  then input where the piece is in the grid below. This solver
                  will tell you if the Kanoodle you've rolled is solvable.
                  (Number of solutions and answers coming soon!). For all
                  possible Kanoodle solutions, check out this{" "}
                  <a
                    href="https://andywarduk.github.io/KanoodleJs/Kanoodle.html"
                    target={"_blank"}
                    rel="noreferrer"
                  >
                    solver
                  </a>{" "}
                  created by{" "}
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://github.com/andywarduk/KanoodleJs"
                  >
                    andywarduk
                  </a>{" "}
                  on GitHub.
                  <br />
                  <br />
                  Select your Kanoodle piece and rotate it into the correct
                  formation.
                  <br />
                  <br />
                  <KanoodlePieceChooser
                    setTransformKanoodlePiece={setTransformKanoodlePiece}
                  />
                  <br />
                  <br />
                  After you've submitted, use the buttons to correctly place it
                  on the grid below. If a button is disabled that means you
                  cannot move the piece that way.
                </Text>
              </Card.Body>
            </Card>
          </Grid>
        </Row>
        <br />
      </Container>
      <Container key={updateKanoodleBoardStateRefresh}>
        <KanoodleBoard piece={transformKanoodlePiece} />
      </Container>
      <hr />
      <footer style={{ padding: 10 }}>
        <Grid.Container justify="center">
          <Grid>
            <a
              href="https://github.com/aleenaloves"
              target="_blank"
              rel="noreferrer"
            >
              aleenaloves
            </a>{" "}
            &copy; {new Date().getFullYear()}
          </Grid>
        </Grid.Container>{" "}
      </footer>
    </Container>
  );
};
